import resolve from 'ioc/resolve'
import Media from 'webutils/media/media'
import ServiceBus from 'servicestack/service-bus'
import S3Uploader from 'webutils/media/s3-uploader'
import modals from 'webmodals/modals'


export default class CreateMedia {
    constructor($files, _req) {
        const me = this;
        me.bus = new ServiceBus();
        me.media = [];
        me.uploaders = $files.map(f => new S3Uploader('CreateMediaItem', f));
        me.all = resolve('$q').all(me.uploaders.map(u => u.upload.then(() => {
            const $cart = resolve('$cart');  //smelly

            let req = Object.assign({
                tags: {},
                contentType: u.file.type,
                euid: u.id,
                label: u.file.name,
                width: u.file.width,
                height: u.file.height,
                originalUrl: u.url()
            }, _req);
            if ($cart.businessModel === 'Wholesale' && $cart.purchaser)
                req.tags['$RetailerId'] = [$cart.purchaser.id];

            u.processing = true;
            return me.bus.send('CreateMediaItem.json', req).then(
                res => me.media.push(u.media = new Media(res.data)),
                res => modals.alert(JSON.stringify(res), 'Could not save media!'));
        })));
    }
}